import React, { useState, useEffect } from "react";
import { Button, notification } from "antd";
import { Row, Col } from 'antd';
import { connect } from "react-redux";
import { setCardId } from "actions";
import _ from 'i18n';
import {
  mangoPayCallback,
  cardWebPayin,
  deactivateCard,
  FeedMangoWalletForOrganizationPayIn,
  getOrganizationCardList,
  mangoPayCallbackForOrganization
} from "../../../actions/thunks/mangoPay";
import { showSpinner, desactivateCard } from "../../../actions/actions/mangoPay";
import CardListFeetching from "../../feetching/mangoPay/CardListFeetching";
import valid from 'card-validator'
import DeleteCardConfirmation from "../../paymentModes/DeleteCardConfirmation";

const openNotificationWithIcon = (type, description, message) => {
  notification[type]({
    message: message,
    description:
      description,
    style: {
      marginTop: 120,
    },
  });
};

const type = {
  v4: {
    httpsUrl: "https://api.ipify.org/"
  },
  v6: {
    httpsUrl: "https://api6.ipify.org/"
  }
};

const UserCardList = ({
  userCardListReducer,
  orderLines,
  currentClient,
  user,
  orderId,
  amount,
  isCreditNote,
  creditNoteId,
  isRefund,
  redirectionURL,
  isCommunity,
  setCardId,
  showSpinner,
  cardWebPayin,
  mangoPayCallback,
  deactivateCard,
  desactivateCard,
  FeedMangoWalletForOrganizationPayIn,
  getOrganizationCardList,
  mangoPayCallbackForOrganization
}) => {

  const [value, setValue] = useState(null);
  const [showInputRegistrationCard, setShowInputRegistrationCard] = useState(false);
  const [pathImageLogo, setPathImageLogo] = useState("");
  const [ipAdress, setIpAdress] = useState("");
  const [tryCount, setTryCount] = useState(5);
  const [id, setId] = useState("");
  const [displayConfirmationModal, setDisplayConfirmationModal] = useState(false);

  useEffect(() => {
    const initData = async () => {
      getOrganizationCardList(currentClient.id);

      const ip = await getIp("v4") || JSON.parse(await getIpJsonTest())['ip'];
      setIpAdress(ip);
    };

    initData();
  }, []);

  //  componentDidUpdate(prevProps) {
  //   if(prevProps.userCardListReducer !== this.props.userCardListReducer && this.props.userCardListReducer.items.length > 0) {
  //     this.setState({value : this.props.userCardListReducer.items[0].Id})
  //     this.props.setCardId(this.props.userCardListReducer.items[0].Id);

  //   }
  // }

  useEffect(() => {
    if (userCardListReducer.items && userCardListReducer.items.length > 0) {
      setValue(userCardListReducer.items[0].Id);
      setCardId(userCardListReducer.items[0].Id);
    }
  }, [userCardListReducer]);

  const getIp = async (version) => {
    const data = type[version];
    try {
      const response = await fetch(data.httpsUrl);
      const ip = await response.text(); //const ip = await response.text();
      return ip;
    } catch (e) {
      if (tryCount > 0) {
        setTryCount(prev => prev - 1);
        return await getIp(version);
      }
      return null;
    }
  };

  const getIpJsonTest = async () => {
    try {
      const response = await fetch("http://ip.jsontest.com/");
      const ip = await response.text(); // await
      return ip;
    } catch (e) {
      return null;
    }
  };



  const onChange = e => {
    setValue(e.target.value);
    setCardId(e.target.value);
  };

  const payinWithCard = (Id) => {
    showSpinner(true)

    const params = {
      'adressIp': ipAdress,
      'javaEnabled': window.navigator.javaEnabled(),
      'Language': window.navigator.language,
      'userAgent': window.navigator.userAgent,
      'timeZoneOffset': new Date().getTimezoneOffset(),
      'colorDepth': screen.colorDepth,
      'screenHeight': screen.height,
      'screenWidth': screen.width,

    }
    if (Id !== null) {
      FeedMangoWalletForOrganizationPayIn(orderId, amount, Id, false, params, isCreditNote, creditNoteId, isRefund, redirectionURL, currentClient.id, user.id).then(res => {
        if (res.data.data.result == "failed") {
          window.open(res.data.data.redirect_url, "_self")
          showSpinner(false)

        } else {
          if (res.data.data.secureMode == true) {
            window.location.assign(res.data.data.redirect_url);
          } else {
            // lancer le thunk pour le post paiement processing
            mangoPayCallbackForOrganization(res.data.data.orderId, res.data.data.transaction_id, 0, creditNoteId, isCreditNote, amount, isRefund, redirectionURL, user.id).then((res) => {
              //ajouter unr notif si le peiement est ok avant de faire la redirection
              if (res.data) {
                window.location.assign(res.data.redirectionUrl);
              }
            })
          }
        }
      })
    }

  }

  const deactivateCardHandler = (Id) => {
    showSpinner(true)
    hideConfirmationModal();
    deactivateCard(Id).then(res => {
      if (!res.data.data.success) {
        showSpinner(false)
        openNotificationWithIcon('error', _('incompleteOperation'), _('error'))
      } else {
        desactivateCard(Id);
        showSpinner(false)
      }
    })
  }

  const showDeleteModal = (id) => {
    setId(id);
    setDisplayConfirmationModal(true);
  };

  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const renderCart = ({ cardDetails, isDeleted }) => {

    //remplacer les X par 1 pour savoir le type de la carte
    let finalAlias = cardDetails.Alias.split("X").join("1");

    var numberValidation = valid.number(finalAlias);
    let pathImageLogo = "";

    if (numberValidation.card) {
      if (numberValidation.card.type == "visa") {
        pathImageLogo = "/img/icons/visa.svg";
      }

      else if (numberValidation.card.type == "mastercard") {
        pathImageLogo = "/img/icons/mastercard (1).svg";
      }

      else if (numberValidation.card.type == "maestro") {
        pathImageLogo = "/img/icons/maestro (2).svg";

      } else {
        pathImageLogo = "";
      }
    }

    return (
      <Row className={'user-card-container mb-3 flex'}>
        <Col span={2} className={'h-full flex justify-center items-center'}>
          {pathImageLogo !== "" ? <span><img src={pathImageLogo} className={'card-type-img'} /> </span> : null}
        </Col>
        <Col span={8}><div className={'h-full flex items-center'}>{cardDetails.Alias}</div></Col>
        <Col span={3}><div className={'h-full flex items-center'}>{cardDetails.ExpirationDate.substr(0, 2) + "/" + cardDetails.ExpirationDate.substr(2)}</div></Col>
        <Col span={9} className={'h-full flex justify-center items-center'}>
          <button key={cardDetails.Id} type="button" onClick={() => payinWithCard(cardDetails.Id)} className={'user-card-button card-list flex items-center ' + (isCommunity ? 'community-theme' : '')}>{_('Payer-avec-cette-carte')}</button>
        </Col>
        {isDeleted ? <Col span={2} className={'flex justify-center'}><img src={"/img/icons/delete-user-card.svg"} onClick={() => showDeleteModal(cardDetails.Id)} className={'card-delete-img'} /></Col> : null}
      </Row>
    )
  }

  if (userCardListReducer.fetching) {
    return <CardListFeetching />;
  }

  return (
    <div>
      {userCardListReducer.items && userCardListReducer.items.length > 0 ? <div>
        {userCardListReducer.items.map(renderCart)}
        <DeleteCardConfirmation id={id} visible={displayConfirmationModal} hideModal={hideConfirmationModal} deleteCard={deactivateCardHandler} />
      </div>
        : null}
    </div>);
}

const mapStateToProps = state => ({
  userCardListReducer: state.userCardListReducer,
  orderLines: state.orderLines,
  currentClient: state.auth.currentClient,
  user: state.auth.user,
});

const mapDispatchToProps = {
  setCardId,
  showSpinner,
  cardWebPayin,
  mangoPayCallback,
  deactivateCard,
  desactivateCard,
  FeedMangoWalletForOrganizationPayIn,
  getOrganizationCardList,
  mangoPayCallbackForOrganization,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserCardList);



// WEBPACK FOOTER //
// ./app/components/Admin/FeedMangoWallet/UserCardList.js